module.exports = _.extend({
  initialize: function () {
    this.progress = 0;
    this.canvas = INKIVE.Tool.getInstance().editor.canvas;
  },

  display: async function (data) {
    await (this._loadingPromise = this._loadingPromise || this._load());

    const projectData = await INKIVE.CompanyFactory.getProjectData();

    this._translationsApp.invoke('toggle', {
      display: true,
      companyId: projectData.company.id,
      template: projectData,
      snapshot: data && data.snapshot
    });
  },

  // TODO: move this to an actual getter instead of handler
  getAllCompleted: function () {
    return this.progress === 1;
  },

  _load: async function () {
    INKIVE.Modal.togglePageLoader(true);
    this._onDisplayParentVersion = this._onDisplayParentVersion.bind(this);
    this._onApply = this._onApply.bind(this);
    this._copyToClipboard = this._copyToClipboard.bind(this);
    this._onToggle = this._onToggle.bind(this);
    this._onSelection = this._onSelection.bind(this);
    this._onCompleted = this._onCompleted.bind(this);
    this._removePreview = this._removePreview.bind(this);
    this._onAdd = this._onAdd.bind(this);
    this.getAllCompleted = this.getAllCompleted.bind(this);

    const appNode = document.createElement('div');
    appNode.id = 'translations-panel';
    appNode.setAttribute('aurelia-app', '@desygner/translations-viewer/main');

    document.querySelector('#content').appendChild(appNode);

    await INKIVE.Helpers.getAureliaLibraries($(appNode));
    const { adapter } = await System.import('@desygner/adapter/adapter');
    this._translationsApp = adapter.getAdapterByDomElement(appNode);
    this._setListeners();

    await new Promise(resolve => INKIVE.Helpers.afterRendering(resolve));
    INKIVE.Modal.togglePageLoader(false);
    INKIVE.EditorFacade.trigger('translation.loaded');
  },

  _setListeners: function () {
    this._translationsApp.on('displayParentVersion', this._onDisplayParentVersion);
    this._translationsApp.on('apply', this._onApply);
    this._translationsApp.on('add', this._onAdd);
    this._translationsApp.on('copyToClipboard', this._copyToClipboard);
    this._translationsApp.on('toggle', this._onToggle);
    this._translationsApp.on('selection', this._onSelection);
    this._translationsApp.on('completed', this._onCompleted);
    this._translationsApp.on('save', this._onSave);
  },

  _onDisplayParentVersion: function ({ image }) {
    document.getElementById('pages-panel').style.display = 'none';

    this._overlay = document.createElement('div');
    this._overlay.style.cssText = `
      height: 100vh;
      width: 100vw;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgb(19, 24, 33, 0.4);
      cursor: pointer;
      z-index: 1000;
      display: none;
    `;

    const eventId = Date.now();
    this._overlay.id = eventId;

    document.body.appendChild(this._overlay);
    INKIVE.DesignFacade.trigger('translations.parent_template_preview.loading', { id: eventId });

    const position = document.getElementById('svgcontent').getBoundingClientRect();

    this._previewNode = new Image();
    this._previewNode.style.cssText = `
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      margin: auto;
    `;

    this._previewNode.setAttribute('height', `${Math.round(position.height)}px`);
    this._previewNode.setAttribute('width', `${Math.round(position.width)}px`);

    this._previewNode.onload = () => {
      this._previewNode.complete &&
      INKIVE.DesignFacade.trigger('translations.parent_template_preview.loaded', { id: eventId });

      this._overlay.appendChild(this._previewNode);
      this._overlay.style.display = 'block';

      document.addEventListener('click', this._removePreview);
    };

    this._previewNode.onerror = () => {
      INKIVE.DesignFacade.trigger('translations.parent_template_preview.error', { id: eventId });
      document.getElementById('pages-panel').style.display = '';
      this.canvas.call('advice.show', 'display-parent-template-error');
    };

    this._previewNode.setAttribute('src', image);
  },

  _removePreview: function () {
    document.getElementById('pages-panel').style.display = '';
    document.body.removeChild(this._overlay);
    document.removeEventListener('click', this._removePreview);
  },

  _onApply: async function ({ id, translation }) {
    INKIVE.hasEditorUnsavedChanges = true;
    const destinationTextarea = document.getElementById(id);
    if (!destinationTextarea) {
      return this._onAdd({ translation });
    }

    const destinationTexts = Array.from(destinationTextarea.querySelectorAll('text'));
    const sourceTexts = Array.from(
      svgedit.utilities.text2xml(`<g>${translation}</g>`)
        .querySelectorAll('text')
    );

    for (const i in sourceTexts) {
      const sourceNode = sourceTexts[i];
      const destinationNode = destinationTexts[i];

      if (destinationNode) {
        destinationNode.innerHTML = this._getInnerHTMLMatchingDeepSpacing(
          sourceNode.innerHTML, destinationNode
        );
      } else {
        destinationTextarea.querySelector('g.text').innerHTML += sourceNode.outerHTML;
      }
    }

    for (let i = sourceTexts.length; i < destinationTexts.length; i++) {
      destinationTexts[i].parentElement.removeChild(destinationTexts[i]);
    }

    const textarea = new INKIVE.Text.Textarea().setDOM(destinationTextarea, false);
    textarea.render(this.canvas);
  },

  _onAdd: async function ({ translation }) {
    const id = await INKIVE.DesignFacade.create('text', { content: '-' }); // doesn't work with empty string
    this._onApply({ id, translation });
  },

  _getInnerHTMLMatchingDeepSpacing: function (innerHTML, referenceNode) {
    const resultNode = referenceNode.cloneNode(true);

    this._overwriteInnerHTMLMatchingSpacing(innerHTML, resultNode, referenceNode);

    const resultFirstChild = resultNode.firstChild;
    const referenceFirstChild = referenceNode.firstChild;
    const shouldMatchInitialTspan = referenceFirstChild && resultFirstChild &&
      referenceFirstChild.nodeName === 'tspan' &&
      resultFirstChild.nodeName === 'tspan'
    ;

    shouldMatchInitialTspan && this._overwriteInnerHTMLMatchingSpacing(
      resultFirstChild.innerHTML, resultFirstChild, referenceFirstChild
    );

    return resultNode.innerHTML;
  },

  _overwriteInnerHTMLMatchingSpacing: function (innerHTML, destinationNode, referenceNode) {
    const initialSpaces = referenceNode.innerHTML.match(/^(\s*).*/)[1];
    destinationNode.innerHTML = initialSpaces + innerHTML.trim();
  },

  _copyToClipboard: async function ({ id, translation }) {
    copyTextToClipboard(translation);
    this.canvas.call('advice.show', 'translation-copied');
  },

  _onToggle: function ({ display }) {
    const sidebarResizeButton = document.getElementById('sidebar-resize-button');
    sidebarResizeButton.style.display = display ? 'none' : '';
  },

  _onSelection: async function ({ task, block }) {
    if (INKIVE.Tool._current_design_id !== task.context.id) {
      await INKIVE.EditorFacade.handle('page', 'move_to', {
        design_id: task.context.id
      });
    }

    INKIVE.EditorFacade.handle('select', block.id);
  },

  _onCompleted: function ({ progress }) {
    this.progress = progress;
  },

  _onSave: async function () {
    await INKIVE.EditorFacade.handle('page', 'save');
  }
}, Backbone.Events);

async function copyTextToClipboard (text) {
  if (!navigator.clipboard) return fallbackCopyTextToClipboard(text);

  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    console.error('Async: Could not copy text', err);
  }
}

function fallbackCopyTextToClipboard (text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Fallback: could not copy text', err);
  }

  document.body.removeChild(textArea);
}
